import { sharedShiftClaimService } from 'api/services';
import { useMutation } from 'react-query';
import { Site } from 'shared/hooks';
import { CancelShiftClaimPayload } from './use-cancel-shift-claim.types';

export const useCancelShiftClaim = (site: Site) => {
  const mutationFn = async ({ shiftClaimId, cancelationReason }: CancelShiftClaimPayload) =>
    await sharedShiftClaimService.cancelShiftClaim(site, shiftClaimId, cancelationReason);

  return useMutation(mutationFn);
};
